export default {
  Button: {
    width: '100%',
    background: '#10AFE2!important',
    padding: '5px 14px!important',
    borderRadius: '8px!important',
    textTransform: 'upperCase !important',
    fontSize: '11px!important',
    lineHeight: '14px!important',
    fontFamily: 'SF UI Display, sans-serif',
    fontStyle: 'normal!important',
    fontWeight: '300!important',
    color: '#fff',
    '@media(min-width: 800px)': {
      fontSize: '12px!important'
    }
  },
  bigButton: {
    background: '#10AFE2!important',
    padding: '14px 16px!important',
    borderRadius: '8px!important',
    textTransform: 'upperCase !important',
    fontSize: '12px!important',
    lineHeight: '14px!important',
    fontFamily: 'SF UI Display, sans-serif',
    fontStyle: 'normal!important',
    fontWeight: '300!important',
    color: '#fff'
  },
  grayButton: {
    background: '#444444 !important',
    padding: '14px 16px!important',
    borderRadius: '8px!important',
    textTransform: 'upperCase !important',
    fontSize: '12px!important',
    lineHeight: '14px!important',
    fontFamily: 'SF UI Display, sans-serif',
    fontStyle: 'normal!important',
    fontWeight: '300!important',
    color: '#fff'
  }
};
